import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import _ from 'lodash';

class EditorData extends React.Component {

  render() {
    const { item, handleOrientationChange, handleChange, styles, disableFields } = this.props
    return (
      <div>
        <h2>Editor Data</h2>
        <div style={{ paddingLeft: '40px', paddingBottom: '20px' }}>
          <SelectField
            value={item.editor.orientation}
            onChange={!disableFields ? handleOrientationChange : ''}
            floatingLabelText="Orientation"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="editor.orientation"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            <MenuItem value="landscape" primaryText="Landscape" />
            <MenuItem value="portrait" primaryText="Portrait" />
          </SelectField>
          <TextField
            floatingLabelText="Border"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={item.editor.border}
            name="editor.border"
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Width"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={item.editor.width}
            name="editor.width"
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Height"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={item.editor.height}
            name="editor.height"
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          <br />
          <TextField
            floatingLabelText="Band Height"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={item.editor.bandHeight}
            name="editor.bandHeight"
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Text Size"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
            value={item.editor.textSize}
            name="editor.textSize"
            onChange={!disableFields ? handleChange : ''}
            style={styles.inputStyle}
          />
        </div>
      </div>
    )
  }
}
export default EditorData


// WEBPACK FOOTER //
// ./src/components/items/Common/EditorData.js